{
  "pt": {
    "lead": {
      "actions": {
        "add_company": "Adicionar empresa",
        "add_lead": "Adicionar lead",
        "new": "Lead"
      },
      "attributes": {
        "address": "Endereço",
        "birth_date": "Data de nascimento",
        "categories": {
          "enduser": "Comprador-ocupante",
          "investor": "Investidor"
        },
        "category": "Tipo de lead",
        "company_name": "Nome da empresa",
        "company_vat": "Número de IVA",
        "email_address": "E-mail",
        "first_name": "Nome próprio",
        "iban": "IBAN",
        "internal_note": "Nota interna",
        "language": "Língua",
        "last_name": "Apelido",
        "phone_landline": "Número de telefone fixo",
        "phone_mobile": "Número de telemóvel",
        "status": "Estado"
      },
      "labels": {
        "detailed_information": "Introduzir informações pormenorizadas",
        "lead": "Lead"
      },
      "validation": {
        "needFirstName": "Nome próprio obrigatório",
        "needLastName": "Apelido obrigatório"
      }
    }
  }
}
